import { LinearGradient as CoreLinearGradient } from '@scatterlab/zeta-core';
import { FC, memo } from 'react';

import type { LinearGradientProps } from './LinearGradient.native';

const LinearGradient: FC<LinearGradientProps> = (props) => (
  <CoreLinearGradient {...props} colors={[]} />
);

export default memo(LinearGradient);